export function testWebGlSupport() {
    let supported = false;
  
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      supported = !!ctx;
    }
    catch (e) {
      console.error(e);
    }
  
    return supported;
  }
  